import React from 'react';
import { useLocation } from 'react-router-dom';
import { PageEnter } from './ui/motion';

/**
 * Route entrance (CC6): a spring fade plus 8px rise, keyed on the pathname so
 * every route change plays it once. Opacity and transform only, so the page
 * never shifts layout while it settles.
 *
 * No exit animation: the old page would keep rendering against the new
 * router location while it faded (params gone, redirects firing), which is
 * how the previous inner fade got stuck at opacity 0. Suspense's PageSkeleton
 * fallback renders inside the visible parent, never inside this wrapper's
 * initial pose, because the wrapper mounts with the resolved page.
 */
const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  return <PageEnter key={pathname}>{children}</PageEnter>;
};

export default PageTransition;
